import type { PriceId } from '@iheartjane/types';

const weightToPriceId: Record<string, PriceId> = {
  'eighth ounce': 'eighth_ounce',
  gram: 'gram',
  'half gram': 'half_gram',
  'half ounce': 'half_ounce',
  ounce: 'ounce',
  'quarter ounce': 'quarter_ounce',
  'two gram': 'two_gram',
  each: 'each',
};

/**
 * Returns the product's in-stock weight price IDs, or an empty array for
 * unit-based products (those with an `amount`, sold as "Each") where
 * individual weight labels are not meaningful.
 */
export const getInStockWeights = (
  availableWeights: readonly string[] | null | undefined,
  amount: string | null | undefined
): PriceId[] => {
  if (amount) return [];

  return (availableWeights ?? []).reduce<PriceId[]>((acc, weight) => {
    const priceId = weightToPriceId[weight];
    if (priceId) acc.push(priceId);
    return acc;
  }, []);
};
